import type { KnucklebonesPlayerDataJSON, QuestGiverDataJSON, ShopkeeperDataJSON } from "../../../types";

import knucklebonesPlayerDataJSON from "./knucklebones-player-data.json";
import questGiverDataJSON from "./quest-giver-data.json";
import shopkeeperDataJSON from "./shopkeeper-data.json";

const knucklebonesPlayerData: KnucklebonesPlayerDataJSON = knucklebonesPlayerDataJSON;
const questGiverData: QuestGiverDataJSON = questGiverDataJSON;
const shopkeeperData: ShopkeeperDataJSON = shopkeeperDataJSON;

export { knucklebonesPlayerData, questGiverData, shopkeeperData };